import { useLocation, useNavigate } from "react-router-dom";
import { Logo, LogoSymbol } from "@/components/Logo";
import { NAV_LINKS, CONTACT } from "@/data/content";
import { scrollToSection } from "@/lib/scroll";

const LEGAL = [
  { label: "Privacy Policy", to: "/privacy-policy" },
  { label: "Cookie Policy", to: "/cookie-policy" },
  { label: "Termini", to: "/termini" },
];

export const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const go = (l) => {
    if (l.type === "route") {
      navigate(l.to);
    } else if (location.pathname !== "/") {
      navigate("/", { state: { scrollTo: l.id } });
    } else {
      scrollToSection(l.id);
    }
  };

  return (
    <footer data-testid="footer" className="relative overflow-hidden bg-navy bg-grid-dark text-white">
      <div className="mx-auto max-w-7xl px-5 pb-10 pt-20 sm:px-8">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <Logo dark />
            <p className="mt-6 font-display text-2xl font-black tracking-tight sm:text-3xl">
              WHERE <span className="text-brand-gradient">VISIBILITY</span> STARTS.
            </p>
            <p className="mt-2 font-mono text-[11px] tracking-[0.3em] text-white/40">360° MARKETING. SOCIAL-FIRST.</p>
            <LogoSymbol className="mt-8 w-24 opacity-80" />
          </div>

          <nav className="md:col-span-3" aria-label="Menu footer">
            <h3 className="font-mono text-[11px] tracking-[0.3em] text-white/40">MENU</h3>
            <ul className="mt-5 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.id}>
                  <button
                    type="button"
                    data-testid={`footer-link-${l.id}`}
                    onClick={() => go(l)}
                    className="text-sm font-semibold text-white/70 transition-colors hover:text-brand-cyan"
                  >
                    {l.label.charAt(0) + l.label.slice(1).toLowerCase()}
                  </button>
                </li>
              ))}
            </ul>
          </nav>

          <div className="md:col-span-2">
            <h3 className="font-mono text-[11px] tracking-[0.3em] text-white/40">SOCIAL</h3>
            <ul className="mt-5 space-y-3">
              <li><a data-testid="footer-instagram" href={CONTACT.instagram} target="_blank" rel="noopener noreferrer" className="text-sm font-semibold text-white/70 transition-colors hover:text-brand-cyan">Instagram</a></li>
              <li><a data-testid="footer-tiktok" href={CONTACT.tiktok} target="_blank" rel="noopener noreferrer" className="text-sm font-semibold text-white/70 transition-colors hover:text-brand-cyan">TikTok</a></li>
              <li><a data-testid="footer-linkedin" href={CONTACT.linkedin} className="text-sm font-semibold text-white/70 transition-colors hover:text-brand-cyan">LinkedIn</a></li>
              <li><a data-testid="footer-facebook" href={CONTACT.facebook} className="text-sm font-semibold text-white/70 transition-colors hover:text-brand-cyan">Facebook</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h3 className="font-mono text-[11px] tracking-[0.3em] text-white/40">CONTATTI</h3>
            <ul className="mt-5 space-y-3 text-sm font-semibold text-white/70">
              <li><a data-testid="footer-email" href={`mailto:${CONTACT.email}`} className="break-all transition-colors hover:text-brand-cyan">{CONTACT.email}</a></li>
              <li><a data-testid="footer-phone" href={`tel:${CONTACT.phoneRaw}`} className="transition-colors hover:text-brand-cyan">{CONTACT.phoneDisplay}</a></li>
              <li className="text-white/40">{CONTACT.location}</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-4 border-t border-white/10 pt-8 text-xs text-white/40 md:flex-row md:items-center md:justify-between">
          <p>© 2026 Starting Point Agency — P.IVA {CONTACT.piva}</p>
          <ul className="flex flex-wrap gap-6">
            {LEGAL.map((l) => (
              <li key={l.label}>
                <a href={l.to} data-testid={`footer-legal-${l.label.toLowerCase().replace(/\s/g, "-")}`} className="transition-colors hover:text-white/80">{l.label}</a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="pointer-events-none select-none overflow-hidden" aria-hidden="true">
        <p className="whitespace-nowrap text-center font-display text-[11vw] font-black leading-[0.8] tracking-tight text-outline-dark opacity-60">
          STARTING POINT
        </p>
      </div>
    </footer>
  );
};
